import { Sidebar as L2RSidebar, styledForMobile } from "@l2r-front/l2r-ui"

export const Sidebar = styledForMobile(L2RSidebar)(({ theme, isMobile }) => ({
    marginBottom: isMobile && theme.spacing(-6),
}))